// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"496":"73055e0a18e41ec9","640":"2a1316fa6141b928","929":"29de20d141ee8f6c"}[chunkId] + ".js";
};